import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSimpleMarkdown from 'vue-simple-markdown'
import 'vue-simple-markdown/dist/vue-simple-markdown.css'

import TypeUtils from '@/util/TypeUtils'

function silentTranslationWarn() {
  console.log(`Exists: ${Object.keys(process.env).includes('VUE_APP_SILENT_TRANSLATIONS')};Type: ${typeof process.env.VUE_APP_SILENT_TRANSLATIONS}`)
  return process.env.NODE_ENV === 'production' || Object.keys(process.env).includes('VUE_APP_SILENT_TRANSLATIONS')
}

// Setup Vue

Vue.use(VueI18n)
Vue.use(VueSimpleMarkdown)

Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperty(Vue.prototype, '$formatUtcDate', { value: TypeUtils.formatUtcDate })
Object.defineProperty(Vue.prototype, '$formatLocalDate', { value: TypeUtils.formatLocalDate })

Vue.config.productionTip = false
const i18n = new VueI18n({
  locale: 'de',
  silentTranslationWarn: silentTranslationWarn()
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
